/// <reference types="./layout.d.mts" />
import * as $bright from "../../../bright/bright.mjs";
import * as $connector from "../../../common/data/connector.mjs";
import * as $data_source from "../../../common/data/data_source.mjs";
import * as $proposal_builder from "../../../common/data/ephemeral/proposal_builder.mjs";
import * as $project from "../../../common/data/project.mjs";
import * as $proposal from "../../../common/data/proposal.mjs";
import * as $proposal_element from "../../../common/data/proposal_element.mjs";
import * as $status from "../../../common/data/status.mjs";
import * as $assoc from "../../../common_common/gleam/assoc.mjs";
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $toggler from "../../../ds/ds/components/toggler.mjs";
import * as $cypress from "../../../ds/ds/cypress.mjs";
import * as $icons from "../../../ds/ds/icons.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $h from "../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $data_cl from "../../data/content_library.mjs";
import * as $model from "../../data/model.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $route from "../../data/route.mjs";
import * as $analytics from "../../frontend/view/analytics.mjs";
import * as $content_library from "../../frontend/view/content_library.mjs";
import * as $copilot from "../../frontend/view/copilot.mjs";
import * as $feed from "../../frontend/view/feed.mjs";
import * as $navbar from "../../frontend/view/navbar.mjs";
import * as $organization from "../../frontend/view/organization.mjs";
import * as $overview from "../../frontend/view/overview.mjs";
import * as $projects from "../../frontend/view/projects.mjs";
import * as $settings from "../../frontend/view/settings.mjs";
import * as $s from "../../frontend/view/styles.mjs";
import { Ok, toList, divideFloat } from "../../gleam.mjs";

function select_page_title(route) {
  if (route instanceof $route.Overview) {
    return new $option.Some("Overview");
  } else if (route instanceof $route.ContentLibrary) {
    return new $option.Some("Content Library");
  } else if (route instanceof $route.Projects) {
    let $ = route[0];
    if ($ instanceof $route.OnGoing) {
      return new $option.Some("Projects");
    } else if ($ instanceof $route.Previous) {
      return new $option.Some("Projects");
    } else if ($ instanceof $route.AddProject) {
      return new $option.Some("New Project");
    } else if ($ instanceof $route.AddProposal) {
      return new $option.Some("New Proposal");
    } else {
      return new $option.None();
    }
  } else if (route instanceof $route.CoPilot) {
    return new $option.Some("Co-pilot");
  } else if (route instanceof $route.Settings) {
    return new $option.Some("Settings");
  } else if (route instanceof $route.Organization) {
    return new $option.Some("Organization");
  } else if (route instanceof $route.Analytics) {
    return new $option.Some("Analytics");
  } else if (route instanceof $route.Support) {
    return new $option.Some("Support");
  } else if (route instanceof $route.NotFound) {
    return new $option.Some("Not Found");
  } else {
    return new $option.None();
  }
}

function select_catchphrase(model) {
  let state = $bright.state(model);
  let user = $state.find_current_user(state);
  let $ = state.route;
  if ($ instanceof $route.Overview) {
    return new $option.Some(
      [
        $l.row(
          toList([$l.align("center"), $l.gap(16)]),
          toList([$cypress.data("catchphrase")]),
          toList([
            $el.text("Hello "),
            $skeleton.hide_loading(
              user,
              200,
              40,
              (user) => { return $el.text(user.name); },
            ),
          ]),
        ),
        $el.text("Your overview and requests at a glance."),
      ],
    );
  } else if ($ instanceof $route.NotFound) {
    return new Some([$el.text("Not Found"), $el.text("Not Found")]);
  } else {
    return new None();
  }
}

function select_action(route) {
  if (route instanceof $route.CoPilot) {
    let $ = route[0];
    if ($ instanceof $route.AiResponse) {
      return $button.links.primary(
        toList([$a.href("/co-pilot")]),
        toList([$icons.small($icons.add()), $el.text("Start new conversation")]),
      );
    } else {
      return $el.none();
    }
  } else {
    return $el.none();
  }
}

function view_proposal_modal(state, proposal_id, modal) {
  let $ = $assoc.get(state.proposals.all, proposal_id);
  if ($ instanceof Ok) {
    let proposal = $[0];
    let $1 = $assoc.get(state.projects, proposal.project_id);
    if ($1 instanceof Ok) {
      let project = $1[0];
      return modal(project, proposal);
    } else {
      return $el.none();
    }
  } else {
    return $el.none();
  }
}

function view_project_modal(state, project_id, modal) {
  let $ = $assoc.get(state.projects, project_id);
  if ($ instanceof Ok) {
    let project = $[0];
    return modal(project);
  } else {
    return $el.none();
  }
}

function view_dangerous_qualification_matrix(proposal_builder) {
  return $proposal_builder.require_qualification_matrix(
    proposal_builder,
    (qm) => {
      let $ = $proposal.count_qualification_matrix_answers(qm);
      let failure = $[1];
      let total = $[2];
      let percent_false = $int.to_string(
        $float.round((divideFloat(failure, total)) * 100.0),
      );
      let title = percent_false + " % of the qualification requirements aren’t met.";
      let explanations = "Are you sure you want to continue with the proposal?";
      let on_cancel = $e.on_click(new $msg.UserClosedModal());
      let _block;
      let _pipe = new $msg.UserConfirmedModalProposalQualificationMatrix();
      let _pipe$1 = new $msg.ProposalBuilder(_pipe);
      _block = $e.on_click(_pipe$1);
      let on_confirm = _block;
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(toList([]), toList([$h.text(title)])),
              $modal.explanations(toList([]), toList([$h.text(explanations)])),
              $modal.actions(
                toList([]),
                toList([
                  $button.primary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.secondary(
                    toList([on_confirm]),
                    toList([$h.text("Continue")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function view_incomplete_qualification_matrix(proposal_builder) {
  return $proposal_builder.require_qualification_matrix(
    proposal_builder,
    (qm) => {
      let $ = $proposal.count_qualification_matrix_answers(qm);
      let success = $[0];
      let failure = $[1];
      let total = $[2];
      let amount = (total - success) - failure;
      let amount$1 = $int.to_string($float.round(amount));
      let title = ("You have " + amount$1) + " unanswered questions";
      let explanations = "Are you sure you want to submit your matrix?";
      let on_cancel = $e.on_click(new $msg.UserClosedModal());
      let _block;
      let _pipe = new $msg.UserConfirmedModalProposalQualificationMatrix();
      let _pipe$1 = new $msg.ProposalBuilder(_pipe);
      _block = $e.on_click(_pipe$1);
      let on_confirm = _block;
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(toList([]), toList([$h.text(title)])),
              $modal.explanations(toList([]), toList([$h.text(explanations)])),
              $modal.actions(
                toList([]),
                toList([
                  $button.primary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.secondary(
                    toList([on_confirm]),
                    toList([$h.text("Continue")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function view_delete_proposal(proposal) {
  let title = ("Are you sure you want to delete " + proposal.name) + "?";
  let explanations = "Deleting the proposal cannot be reverted.";
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let on_confirm = $e.on_click(
    new $msg.Proposal(new $msg.UserDeletedProposal(proposal.id)),
  );
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(toList([]), toList([$h.text(title)])),
          $modal.explanations(toList([]), toList([$h.text(explanations)])),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([on_confirm]),
                toList([$h.text("Delete")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function view_delete_question_in_proposal(element) {
  let title = "Are you sure you want the delete the question ?";
  let explanations = "This line will still be present in the exported file just without an AI answer.";
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let id = $proposal_element.id(element);
  let proposal_id = $proposal_element.proposal_id(element);
  let _block;
  let _pipe = new $msg.UserDeletedQuestionInProposal(proposal_id, id);
  let _pipe$1 = new $msg.Proposal(_pipe);
  _block = $e.on_click(_pipe$1);
  let on_confirm = _block;
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(toList([]), toList([$h.text(title)])),
          $modal.explanations(toList([]), toList([$h.text(explanations)])),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([on_confirm]),
                toList([$h.text("Delete")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function construct_deletion_title(data_source) {
  let $ = data_source.kind;
  if ($ instanceof $connector.GoogleDrive) {
    return "Are you sure you want to disconnect this page?";
  } else if ($ instanceof $connector.Confluence) {
    return "Are you sure you want to disconnect this page?";
  } else if ($ instanceof $connector.Notion) {
    return "Are you sure you want to disconnect this page?";
  } else if ($ instanceof $connector.OneDrive) {
    return "Are you sure you want to disconnect this page?";
  } else if ($ instanceof $connector.Steerlab) {
    return "Are you sure you want to delete this file ?";
  } else if ($ instanceof $connector.SteerlabQna) {
    return "Are you sure you want to delete this Q&A pair ?";
  } else {
    return "Are you sure you want to delete this content ?";
  }
}

function construct_deletion_sub_title(data_source) {
  let friendly_source_name = $connector.format(data_source.kind);
  let $ = data_source.kind;
  if ($ instanceof $connector.GoogleDrive) {
    return ("Since this file is syncronised with your " + friendly_source_name) + " you also need to go to the integrations page to stop the syncronisation.";
  } else if ($ instanceof $connector.Confluence) {
    return ("Since this file is syncronised with your " + friendly_source_name) + " you also need to go to the integrations page to stop the syncronisation.";
  } else if ($ instanceof $connector.Website) {
    return ("Since this file is syncronised with your " + friendly_source_name) + " you also need to go to the integrations page to stop the syncronisation.";
  } else if ($ instanceof $connector.Notion) {
    return ("Since this file is syncronised with your " + friendly_source_name) + " you also need to go to the integrations page to stop the syncronisation.";
  } else if ($ instanceof $connector.OneDrive) {
    return ("Since this file is syncronised with your " + friendly_source_name) + " you also need to go to the integrations page to stop the syncronisation.";
  } else if ($ instanceof $connector.Steerlab) {
    return "Deleting this content cannot be reverted.";
  } else if ($ instanceof $connector.SteerlabQna) {
    return "Deleting this Q&A pair cannot be reverted.";
  } else {
    return "Deleting this content cannot be reverted.";
  }
}

function construct_cta_button_text(data_source) {
  let $ = data_source.kind;
  if ($ instanceof $connector.GoogleDrive) {
    return "Disconnect";
  } else if ($ instanceof $connector.Confluence) {
    return "Disconnect";
  } else if ($ instanceof $connector.Notion) {
    return "Disconnect";
  } else if ($ instanceof $connector.OneDrive) {
    return "Disconnect";
  } else {
    return "Delete";
  }
}

function view_delete_data_source(data_source) {
  let title = construct_deletion_title(data_source);
  let explanations = construct_deletion_sub_title(data_source);
  let cta_text = construct_cta_button_text(data_source);
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let on_confirm = $e.on_click(
    new $msg.ContentLibrary(new $msg.UserDeletedDataSource(data_source.id)),
  );
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(toList([]), toList([$h.text(title)])),
          $modal.explanations(toList([]), toList([$h.text(explanations)])),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([on_confirm]),
                toList([$h.text(cta_text)]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function view_change_project_status(project, status) {
  let _block;
  let $ = project.status;
  if (status instanceof $status.InProgress) {
    if ($ instanceof $status.InProgress) {
      _block = toList([]);
    } else {
      _block = toList([
        $h.text("This will remove your project from the content library."),
      ]);
    }
  } else if ($ instanceof $status.InProgress) {
    _block = toList([
      $h.text("This will add your project to the content library."),
    ]);
  } else {
    _block = toList([]);
  }
  let explanations = _block;
  let title = ((("Are you sure you want to change \"" + project.name) + "\" status to ") + $status.to_string(
    status,
  )) + "?";
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let on_confirm = $e.on_click(
    new $msg.Project(new $msg.UserChangedProjectStatus(project.id, status)),
  );
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(toList([]), toList([$h.text(title)])),
          $modal.explanations(toList([]), explanations),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([on_confirm]),
                toList([$h.text("Submit")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function emphasis(color, text) {
  return $h.span(
    toList([
      $a.style("color", color),
      $a.style("white-space", "nowrap"),
      $a.style("font-weight", "500"),
    ]),
    toList([$h.text(text)]),
  );
}

function view_retrigger_proposal_questions(proposal, override_validated) {
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let _block;
  let _pipe = override_validated;
  let _pipe$1 = new $msg.UserWillRetriggerProposal(_pipe);
  let _pipe$2 = new $msg.ProposalBuilder(_pipe$1);
  _block = $e.on_click(_pipe$2);
  let on_confirm = _block;
  let on_change = $toggler.on_change(
    (value) => {
      let _pipe$3 = new $msg.UserToggledOverrideValidated(proposal.id, value);
      return new $msg.ProposalBuilder(_pipe$3);
    },
  );
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(
            toList([]),
            toList([$h.text("Replace all existing answers?")]),
          ),
          $modal.explanations(
            toList([]),
            toList([
              $h.text("You're about to replace the answers marked "),
              emphasis($colors.light.blue_800, "In Review"),
              $h.text(" with new content."),
              $h.br(toList([])),
              $h.br(toList([])),
              $h.text("This action is permanent and cannot be undone. "),
              $h.text("Do you want to continue?"),
              $h.br(toList([])),
              $h.br(toList([])),
              $l.row(
                toList([$l.gap(16), $l.align("center")]),
                toList([]),
                toList([
                  $toggler.toggler(
                    toList([$toggler.active(override_validated), on_change]),
                  ),
                  $l.row(
                    toList([$l.gap(3), $l.align("center")]),
                    toList([]),
                    toList([
                      $h.text("Also overwrite"),
                      emphasis($colors.light.success_800, "Validated"),
                      $h.text("answers"),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([on_confirm]),
                toList([$h.text("Submit")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function view_delete_project(project, confirm_input) {
  let on_cancel = $e.on_click(new $msg.UserClosedModal());
  let _block;
  let _pipe = new $msg.UserDeletedProject(project.id);
  let _pipe$1 = new $msg.Project(_pipe);
  _block = $e.on_click(_pipe$1);
  let on_confirm = _block;
  return $modal.modal(
    toList([]),
    toList([
      $modal.body(
        toList([$utils.stop_propagation()]),
        toList([
          $modal.title(toList([]), toList([$h.text("Delete project?")])),
          $modal.explanations(
            toList([]),
            toList([
              $h.text("You're about to delete the project "),
              emphasis($colors.light.blue_800, project.name),
              $h.text(" and all associated proposals."),
              $h.br(toList([])),
              $h.br(toList([])),
              $h.text("This action is permanent and cannot be undone. "),
              $h.text("Do you want to continue?"),
              $h.br(toList([])),
              $h.br(toList([])),
              $l.column(
                toList([$l.gap(8)]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(3), $l.align("center")]),
                    toList([]),
                    toList([
                      $h.text("Enter"),
                      emphasis($colors.light.error_800, "Confirm"),
                      $h.text("below to confirm"),
                    ]),
                  ),
                  (() => {
                    let _pipe$2 = $input.input(
                      toList([
                        $input.value(confirm_input),
                        $input.on_input(
                          (var0) => {
                            return new $msg.UserEditedDeleteConfirmInput(var0);
                          },
                        ),
                      ]),
                    );
                    return $el.map(
                      _pipe$2,
                      (var0) => { return new $msg.Project(var0); },
                    );
                  })(),
                ]),
              ),
            ]),
          ),
          $modal.actions(
            toList([]),
            toList([
              $button.primary(toList([on_cancel]), toList([$h.text("Cancel")])),
              $button.secondary(
                toList([$a.disabled(confirm_input !== "Confirm"), on_confirm]),
                toList([$h.text("Submit")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function view_modal(model) {
  let state = $bright.state(model);
  let $ = state.modal;
  if ($ instanceof $state.NoModal) {
    return $el.none();
  } else if ($ instanceof $state.DeleteDataSource) {
    let id = $.id;
    let _pipe = state.content_library.non_qna_sources;
    let _pipe$1 = $data_cl.get_sources_list(_pipe);
    let _pipe$2 = $list.append(
      _pipe$1,
      (() => {
        let _pipe$2 = state.content_library.qna_sources;
        return $data_cl.get_sources_list(_pipe$2);
      })(),
    );
    let _pipe$3 = $list.find(_pipe$2, (s) => { return s.id === id; });
    let _pipe$4 = $result.map(_pipe$3, view_delete_data_source);
    return $result.unwrap(_pipe$4, $el.none());
  } else if ($ instanceof $state.DeleteProposal) {
    let id = $.id;
    return view_proposal_modal(
      state,
      id,
      (_, proposal) => { return view_delete_proposal(proposal); },
    );
  } else if ($ instanceof $state.DeleteProposalQuestion) {
    let proposal_id = $.proposal_id;
    let element_id = $.question_id;
    let _pipe = $model.find_element(state, proposal_id, element_id);
    let _pipe$1 = $result.map(_pipe, view_delete_question_in_proposal);
    return $result.unwrap(_pipe$1, $el.none());
  } else if ($ instanceof $state.DangerousQualificationMatrix) {
    return view_dangerous_qualification_matrix(state.proposal_builder);
  } else if ($ instanceof $state.IncompleteQualificationMatrix) {
    return view_incomplete_qualification_matrix(state.proposal_builder);
  } else if ($ instanceof $state.ChangeProjectStatus) {
    let id = $.project_id;
    let status = $.status;
    return view_project_modal(
      state,
      id,
      (project) => { return view_change_project_status(project, status); },
    );
  } else if ($ instanceof $state.RetriggerProposalQuestions) {
    let id = $.proposal_id;
    let override_validated = $.override_validated;
    return view_proposal_modal(
      state,
      id,
      (_, proposal) => {
        return view_retrigger_proposal_questions(proposal, override_validated);
      },
    );
  } else {
    let id = $.id;
    let confirm_input = $.confirm_input;
    return view_project_modal(
      state,
      id,
      (project) => { return view_delete_project(project, confirm_input); },
    );
  }
}

export function view(model) {
  let state = $bright.state(model);
  let page_title = select_page_title(state.route);
  let catchphrase = select_catchphrase(model);
  return $l.fragment(
    toList([
      $s.layout(
        toList([]),
        toList([
          $navbar.navbar(model),
          (() => {
            let _pipe = $feed.feed(model);
            return $el.map(
              _pipe,
              (var0) => { return new $msg.Notifications(var0); },
            );
          })(),
          $s.main(
            toList([$a.id("layout-main"), $cypress.data("layout-main")]),
            toList([
              (() => {
                if (catchphrase instanceof $option.Some) {
                  if (page_title instanceof $option.Some) {
                    let title = catchphrase[0][0];
                    let subtitle = catchphrase[0][1];
                    let t = page_title[0];
                    return $s.page_header(
                      toList([$cypress.data("header")]),
                      toList([
                        $l.column(
                          toList([$l.gap(24)]),
                          toList([]),
                          toList([
                            $s.page_title(toList([]), toList([$h.text(t)])),
                            $s.page_catchphrase(
                              toList([]),
                              toList([
                                $s.catch_title(toList([]), toList([title])),
                                $s.catch_subtitle(
                                  toList([]),
                                  toList([subtitle]),
                                ),
                              ]),
                            ),
                          ]),
                        ),
                        select_action(state.route),
                      ]),
                    );
                  } else {
                    let title = catchphrase[0][0];
                    let subtitle = catchphrase[0][1];
                    return $s.page_header(
                      toList([$cypress.data("header")]),
                      toList([
                        $s.page_catchphrase(
                          toList([]),
                          toList([
                            $s.catch_title(toList([]), toList([title])),
                            $s.catch_subtitle(toList([]), toList([subtitle])),
                          ]),
                        ),
                        select_action(state.route),
                      ]),
                    );
                  }
                } else if (page_title instanceof $option.Some) {
                  let t = page_title[0];
                  return $s.page_header(
                    toList([$cypress.data("header")]),
                    toList([
                      $s.page_title(toList([]), toList([$h.text(t)])),
                      select_action(state.route),
                    ]),
                  );
                } else {
                  return $el.none();
                }
              })(),
              (() => {
                let $ = state.route;
                if ($ instanceof $route.Overview) {
                  return $overview.view(model);
                } else if ($ instanceof $route.ContentLibrary) {
                  return $content_library.view(model);
                } else if ($ instanceof $route.Projects) {
                  return $projects.view(model);
                } else if ($ instanceof $route.CoPilot) {
                  return $copilot.view(model);
                } else if ($ instanceof $route.Settings) {
                  return $settings.view(model);
                } else if ($ instanceof $route.Organization) {
                  return $organization.view(model);
                } else if ($ instanceof $route.Analytics) {
                  return $analytics.view(model);
                } else {
                  return $el.none();
                }
              })(),
            ]),
          ),
        ]),
      ),
      view_modal(model),
    ]),
  );
}
